import type { ChatTool, ToolUseProps } from "../components/Chat/ChatTool";
import { ToolStatus } from "../components/Chat/ToolStatus";
import { Text } from "../components/Text";

function UseSkillHeader({ result, interrupted }: ToolUseProps) {
  const done = !!result && !result.isError;
  return (
    <ToolStatus
      icon="graduation-cap"
      text={done ? "Noodled skills" : "Noodling skills…"}
      pending={!done && !interrupted}
    />
  );
}

function UseSkillBody({ toolUse, result }: ToolUseProps) {
  return (
    <Text variant="code-small" color="var(--text-secondary)">
      <pre
        style={{ margin: 0, whiteSpace: "pre-wrap", wordBreak: "break-word" }}
      >
        {JSON.stringify(toolUse.input, null, 2)}
      </pre>
      {result && (
        <pre
          style={{ margin: 0, whiteSpace: "pre-wrap", wordBreak: "break-word" }}
        >
          {JSON.stringify(result.output, null, 2)}
        </pre>
      )}
    </Text>
  );
}

export const useSkill: ChatTool = {
  name: "useSkill",
  Header: UseSkillHeader,
  Body: UseSkillBody,
};
